import { useSite } from "@/lib/site";

const AR = ["قص شعر", "حلاقة اللحية", "قص شعر + لحية", "تدليل اللحية", "صالون نسائي", "صالون رجالي", "عروض خاصة", "حجز مواعيد"];
const FR = ["Coupe de cheveux", "Rasage de la barbe", "Coupe + barbe", "Soin de la barbe", "Salon féminin", "Salon masculin", "Offres spéciales", "Réservation en ligne"];

function Track({ items, hidden = false }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-head text-lg font-bold text-gold/90">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/40" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  const { lang } = useSite();
  const items = lang === "fr" ? FR : AR;
  return (
    <div className="overflow-hidden border-y border-gold/15 bg-forest-950 py-5" data-testid="services-marquee">
      <div className="marquee-track">
        <Track items={items} />
        <Track items={items} hidden />
      </div>
    </div>
  );
}
